import { loadRenamedColumns, getDisplayName } from './converterHelperFunctions';

export function escapeCSV(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);

  if (/[",n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}



export function generateCsvForEntries(entries, selectedColumns) {
  const updatedEntries = [];
  for (const entry of entries) {
    try {
      const blob = generateCSVLong_main(entry, selectedColumns);
      const url = URL.createObjectURL(blob);
      entry.csvUrl = url;
      entry.status = 'ready';
      entry.progress = 100;
    } catch (err) {
      entry.status = 'error';
      entry.parseError = 'CSV generation error: ' + (err && err.message ? err.message : 'unknown error');
    }
    updatedEntries.push(entry);
  }

  return updatedEntries;
}



export function generateCSVLong_main(entry, selectedColumns) {
  const parsedJson = entry.parsed;

  if (!parsedJson || !parsedJson.timeseries || !Array.isArray(parsedJson.timeseries.data)) {
    throw new Error('Missing timeseries.data');
  }

  const ts = parsedJson.timeseries;
  const data = ts.data;
  const header = selectedColumns.filter(c => entry.headerColumns.includes(c));
  const raw = selectedColumns.filter(c => entry.rawColumns.includes(c));

  const columnNames = loadRenamedColumns();

  const nameToKey = {};
  if (ts.header && ts.header.column) {
    for (const k of Object.keys(ts.header.column)) {
      const name = ts.header.column[k].name;
      if (!nameToKey[name]) nameToKey[name] = k;
    }
  }

  const metaDataMap = {};
  for (const col of header) {
    if (parsedJson[col] !== undefined) metaDataMap[col] = parsedJson[col];
  }

  const headerValues = [];
  for (const col of header) {
    if (parsedJson[col] !== undefined) headerValues.push(parsedJson[col]);
  }

  const parts = [];
  if (header.length > 0) {
    parts.push(header.map(c => escapeCSV(getDisplayName(c, columnNames))).join(','));
    parts.push(headerValues.map(escapeCSV).join(','));

    parts.push('');
    parts.push('');
    parts.push('');
  }

  parts.push(raw.map(c => escapeCSV(getDisplayName(c, columnNames))).join(','));

  for (const record of data) {
    const row = raw.map(col => {
      if (col === 'ts') return escapeCSV(record.ts);
      const key = nameToKey[col];
      const v = (key !== undefined && record.f) ? record.f[key] : '';
      return escapeCSV(v);
    });
    parts.push(row.join(','));
  }

  const csvString = parts.join('\n');
  return new Blob([csvString], { type: 'text/csv;charset-utf-8;' });

}